"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.textInputDocument = void 0;
var types_1 = require("../../../types");
exports.textInputDocument = {
    dateCreated: "2021-07-26T19:09:11Z",
    form: {
        id: 1196401,
        displayConditions: [],
        name: "Some Text Inputs",
        rootId: 1196401,
        sections: [
            {
                id: 1196501,
                items: [
                    {
                        answerSource: {
                            dataSourceKey: "123423",
                            type: "DATA_SOURCE",
                        },
                        id: 1196601,
                        rootId: 1196602,
                        subType: "TEXT_LINE",
                        title: "Title",
                        type: "QUESTION",
                        workflowType: "FINAL",
                    },
                    {
                        id: 1196801,
                        rootId: 1196801,
                        subType: "TEXT_AREA",
                        title: "Body",
                        type: "QUESTION",
                        workflowType: "FINAL",
                    },
                ],
                rootId: 1196501,
                title: "Some Text Inputs",
                workflowType: "FINAL",
            },
        ],
        type: {
            active: true,
            id: 1,
            name: "Head Scratchers",
            isGlobal: true,
        },
        workflowType: "FINAL",
    },
    formActionRequests: [],
    formSummary: {
        id: 1196401,
        name: "Some Text Inputs",
        rootId: 1196401,
        type: {
            active: true,
            id: 1,
            name: "Head Scratchers",
            isGlobal: true,
        },
        workflowType: "FINAL",
    },
    id: 1201151,
    operationalExperiences: [],
    owner: {
        fullName: 'Riley, Todd "The Toddster"',
        name: "Todd Riley",
        participantId: 1062251,
    },
    participants: [],
    photos: [],
    readOnly: false,
    responses: [],
    resubmissions: [],
    sectionComments: [],
    startDate: "2021-07-26T19:09:11Z",
    status: types_1.DocumentStatus.NEW,
    submissionDate: "2021-07-26T19:09:11Z",
    submissionId: 1201201,
    submissionType: types_1.DocumentSubmissionType.NEW,
    summary: {},
    title: "New Document",
};
//# sourceMappingURL=textInputDocument.js.map